import React from "react";

/**
 * Footer component
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="bg-black text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8">
          {/* About Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">About</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="hover:text-yellow-400 transition">
                  My Story
                </a>
              </li>
              <li>
                <a href="/" className="hover:text-yellow-400 transition">
                  Philosophy
                </a>
              </li>
              <li>
                <a href="/" className="hover:text-yellow-400 transition">
                  Press
                </a>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="hover:text-yellow-400 transition">
                  Blog
                </a>
              </li>
              <li>
                <a href="/" className="hover:text-yellow-400 transition">
                  Podcast
                </a>
              </li>
              <li>
                <a href="/" className="hover:text-yellow-400 transition">
                  Free Guides
                </a>
              </li>
            </ul>
          </div>

          {/* Events Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Events</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="hover:text-yellow-400 transition">
                  Upcoming Seminars
                </a>
              </li>
              <li>
                <a href="/" className="hover:text-yellow-400 transition">
                  Virtual Events
                </a>
              </li>
              <li>
                <a href="/" className="hover:text-yellow-400 transition">
                  Past Events
                </a>
              </li>
            </ul>
          </div>

          {/* Connect Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Connect</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="hover:text-yellow-400 transition">
                  Contact
                </a>
              </li>
              <li>
                <a href="/" className="hover:text-yellow-400 transition">
                  Support
                </a>
              </li>
              <li>
                <div className="flex space-x-4 mt-2">
                  <a
                    href="/"
                    className="text-white hover:text-yellow-400 flex items-center justify-center h-8 w-8 rounded-full border border-gray-700"
                    aria-label="Facebook"
                  >
                    <span className="font-bold">f</span>
                  </a>

                  <a
                    href="/"
                    className="text-white hover:text-yellow-400 flex items-center justify-center h-8 w-8 rounded-full border border-gray-700"
                    aria-label="Twitter"
                  >
                    <span className="font-bold">X</span>
                  </a>

                  <a
                    href="/"
                    className="text-white hover:text-yellow-400 flex items-center justify-center h-8 w-8 rounded-full border border-gray-700"
                    aria-label="LinkedIn"
                  >
                    <span className="font-bold">in</span>
                  </a>

                  <a
                    href="/"
                    className="text-white hover:text-yellow-400 flex items-center justify-center h-8 w-8 rounded-full border border-gray-700"
                    aria-label="Instagram"
                  >
                    <span className="font-bold">IG</span>
                  </a>

                  <a
                    href="/"
                    className="text-white hover:text-yellow-400 flex items-center justify-center h-8 w-8 rounded-full border border-gray-700"
                    aria-label="YouTube"
                  >
                    <span className="font-bold">▶</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} Tudor Emanuel. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
